/* HOUSE OF ASHTON — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';
  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
    if (!els.length) return;
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-mt-delay') || 0;
            setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Parallax ligero (solo transform, sin fixed) ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reducedMotion()) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var intensity = Number(el.getAttribute('data-mt-parallax')) || 20;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var offset = Math.max(-1, Math.min(1, progress)) * intensity;
        el.style.setProperty('--mt-parallax-y', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Carrusel "The Edit" ---------- */
  function initCarrusel() {
    var wraps = document.querySelectorAll('[data-mt-carrusel]');
    wraps.forEach(function (wrap) {
      var pista = wrap.querySelector('[data-mt-carrusel-pista]');
      var prev = wrap.querySelector('[data-mt-carrusel-prev]');
      var next = wrap.querySelector('[data-mt-carrusel-next]');
      if (!pista) return;
      function paso() {
        var item = pista.querySelector('[data-mt-carrusel-item]');
        return item ? item.getBoundingClientRect().width + 24 : 320;
      }
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Selector de variantes (producto) ---------- */
  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var ambito = form.parentElement || form;
      var inputId = form.querySelector('input[name="id"]');
      var precioEl = ambito.querySelector('[data-mt-precio]');
      var precioComparado = ambito.querySelector('[data-mt-precio-comparado]');
      var ahorroEl = ambito.querySelector('[data-mt-ahorro]');
      var botonEl = form.querySelector('[data-mt-boton-add]');
      var grupos = form.querySelectorAll('[data-mt-grupo-opcion]');
      var seccionRaiz = form.closest('.mt-producto') || ambito;
      var galeriaPrincipal = seccionRaiz.querySelector('[data-mt-galeria-principal]');
      var galeriaImg = galeriaPrincipal ? galeriaPrincipal.querySelector('img') : null;
      var miniaturas = seccionRaiz.querySelectorAll('[data-mt-galeria-mini]');

      function formatoDinero(centavos) {
        var numero = (centavos / 100).toLocaleString('es-ES', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return numero + ' €';
      }

      function seleccionActual() {
        return Array.prototype.map.call(grupos, function (grupo) {
          var activo = grupo.querySelector('.mt-activa[data-mt-opcion]');
          return activo ? activo.getAttribute('data-valor') : null;
        });
      }

      function actualizar() {
        var seleccion = seleccionActual();
        var variante = variantes.find(function (v) {
          return v.options.every(function (op, i) { return op === seleccion[i]; });
        });
        if (!variante) {
          if (botonEl) { botonEl.disabled = true; botonEl.textContent = botonEl.getAttribute('data-mt-texto-no-disponible') || 'No disponible'; }
          return;
        }
        if (inputId) inputId.value = variante.id;
        if (precioEl) precioEl.textContent = formatoDinero(variante.price);
        if (precioComparado) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioComparado.textContent = formatoDinero(variante.compare_at_price);
            precioComparado.style.display = '';
          } else {
            precioComparado.style.display = 'none';
          }
        }
        if (ahorroEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            var ahorroTexto = ahorroEl.getAttribute('data-mt-ahorro-texto') || 'AHORRAS';
            ahorroEl.textContent = ahorroTexto + ' ' + formatoDinero(variante.compare_at_price - variante.price);
            ahorroEl.hidden = false;
          } else {
            ahorroEl.hidden = true;
          }
        }
        if (botonEl) {
          if (variante.available) {
            botonEl.disabled = false;
            botonEl.textContent = botonEl.getAttribute('data-mt-texto-add') || 'Añadir a la cesta';
          } else {
            botonEl.disabled = true;
            botonEl.textContent = botonEl.getAttribute('data-mt-texto-agotado') || 'Agotado';
          }
        }
        if (variante.featured_media_id && galeriaPrincipal) {
          var miniActiva = null;
          miniaturas.forEach(function (mini) {
            var esEsta = String(mini.getAttribute('data-media-id')) === String(variante.featured_media_id);
            mini.classList.toggle('mt-activa', esEsta);
            if (esEsta) miniActiva = mini;
          });
          galeriaPrincipal.setAttribute('data-media-id', variante.featured_media_id);
          if (galeriaImg) {
            var nuevaUrl = (miniActiva && miniActiva.getAttribute('data-full')) || variante.featured_image_url;
            var nuevoAlt = miniActiva ? miniActiva.getAttribute('data-alt') : null;
            if (nuevaUrl) galeriaImg.src = nuevaUrl;
            if (nuevoAlt) galeriaImg.alt = nuevoAlt;
          }
        }
      }

      grupos.forEach(function (grupo) {
        var valorActualEl = grupo.querySelector('[data-mt-opcion-valor-actual]');
        var botones = grupo.querySelectorAll('[data-mt-opcion]');
        botones.forEach(function (boton) {
          boton.addEventListener('click', function () {
            botones.forEach(function (b) { b.classList.remove('mt-activa'); });
            boton.classList.add('mt-activa');
            if (valorActualEl) valorActualEl.textContent = boton.getAttribute('data-valor');
            actualizar();
          });
        });
      });
      actualizar();
    });
  }

  /* ---------- Muestras de color (swatches) ---------- */
  var MT_COLORES = {
    'negro': '#161412', 'black': '#161412',
    'blanco': '#FFFFFF', 'white': '#FFFFFF',
    'crudo': '#F2EAD8', 'off-white': '#F2EAD8', 'off white': '#F2EAD8',
    'beige': '#D8C7A8', 'arena': '#D8C7A8', 'sand': '#D8C7A8',
    'piedra': '#B9AC97', 'stone': '#B9AC97',
    'camel': '#B18A5C', 'camello': '#B18A5C',
    'marron': '#5B3A29', 'marrón': '#5B3A29', 'brown': '#5B3A29', 'chocolate': '#3E2723',
    'gris': '#9B9691', 'grey': '#9B9691', 'gray': '#9B9691',
    'gris claro': '#D3CFC9', 'gris oscuro': '#4B4844',
    'azul': '#3A5A8C', 'blue': '#3A5A8C', 'azul marino': '#1F2C42', 'navy': '#1F2C42',
    'azul cielo': '#A9C6E8', 'celeste': '#A9C6E8',
    'verde': '#4C6B4F', 'green': '#4C6B4F', 'verde oliva': '#6B6E4E', 'khaki': '#6B6E4E', 'caqui': '#6B6E4E',
    'rojo': '#A63A34', 'red': '#A63A34', 'burdeos': '#6B222A', 'burgundy': '#6B222A', 'vino': '#6B222A',
    'rosa': '#E3B7BE', 'pink': '#E3B7BE', 'rosa palo': '#E7CBC6', 'fucsia': '#C13584',
    'malva': '#C6A9BE', 'lila': '#C9B6DA', 'lavanda': '#D9CCEA', 'morado': '#5B3A6E', 'purple': '#5B3A6E',
    'amarillo': '#E4C55E', 'yellow': '#E4C55E', 'mostaza': '#C79A3D', 'mustard': '#C79A3D',
    'naranja': '#C96A3E', 'orange': '#C96A3E', 'terracota': '#B5613F', 'terracotta': '#B5613F',
    'coral': '#E08469', 'dorado': '#C9AE94', 'gold': '#C9AE94', 'plateado': '#C7C7C7', 'silver': '#C7C7C7',
    'multicolor': 'conic-gradient(from 0deg, #A63A34, #E4C55E, #4C6B4F, #3A5A8C, #5B3A6E, #A63A34)',
    'estampado': 'conic-gradient(from 0deg, #A63A34, #E4C55E, #4C6B4F, #3A5A8C, #5B3A6E, #A63A34)'
  };

  var MT_COLORES_CLAVES = Object.keys(MT_COLORES).sort(function (a, b) { return b.length - a.length; });

  function buscarColor(nombre) {
    if (MT_COLORES[nombre]) return { clave: nombre, valor: MT_COLORES[nombre] };
    // El valor de la variante puede incluir texto extra (ej. "Black 3-piece set"):
    // busca el nombre de color conocido más largo que aparezca como palabra suelta.
    for (var i = 0; i < MT_COLORES_CLAVES.length; i++) {
      var clave = MT_COLORES_CLAVES[i];
      var patron = new RegExp('(^|[^a-z0-9])' + clave.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^a-z0-9])');
      if (patron.test(nombre)) return { clave: clave, valor: MT_COLORES[clave] };
    }
    return null;
  }

  function initSwatches() {
    document.querySelectorAll('.mt-swatch').forEach(function (el) {
      var nombre = (el.getAttribute('data-color-nombre') || '').trim().toLowerCase();
      var encontrado = buscarColor(nombre);
      var valor = encontrado ? encontrado.valor : null;
      var clave = encontrado ? encontrado.clave : nombre;
      if (!valor) {
        // intenta también como color CSS válido directo (ej. "coral", "teal"...)
        var prueba = new Option().style;
        prueba.color = nombre;
        valor = prueba.color ? nombre : 'var(--mt-color-linea)';
      }
      if (valor.indexOf('gradient') > -1) {
        el.style.backgroundImage = valor;
      } else {
        el.style.backgroundColor = valor;
      }
      if (clave === 'blanco' || clave === 'white') {
        el.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.15)';
      }
    });
  }

  /* ---------- Selector de cantidad ---------- */
  function initCantidad() {
    document.querySelectorAll('[data-mt-cantidad]').forEach(function (grupo) {
      var input = grupo.querySelector('[data-mt-cantidad-input]');
      var menos = grupo.querySelector('[data-mt-cantidad-menos]');
      var mas = grupo.querySelector('[data-mt-cantidad-mas]');
      if (!input) return;
      function fijar(valor) {
        input.value = Math.max(1, valor);
      }
      if (menos) menos.addEventListener('click', function () { fijar((parseInt(input.value, 10) || 1) - 1); });
      if (mas) mas.addEventListener('click', function () { fijar((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('change', function () { fijar(parseInt(input.value, 10) || 1); });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal] img');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.src = mini.getAttribute('data-full') || mini.src;
          principal.srcset = '';
          minis.forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  /* ---------- Menú móvil / mega-menu ---------- */
  function initMenu() {
    var toggles = document.querySelectorAll('[data-mt-menu-toggle]');
    toggles.forEach(function (toggle) {
      var targetId = toggle.getAttribute('data-mt-menu-toggle');
      var target = document.getElementById(targetId);
      if (!target) return;
      toggle.addEventListener('click', function () {
        var abierto = target.classList.toggle('mt-abierto');
        toggle.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = Number(el.getAttribute('data-mt-contador')) || 0;
        var dur = 1400;
        var inicio = performance.now();
        function tick(ahora) {
          var progreso = Math.min(1, (ahora - inicio) / dur);
          el.textContent = Math.floor(progreso * fin).toString();
          if (progreso < 1) requestAnimationFrame(tick);
          else el.textContent = fin.toString();
        }
        requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Barra de descuento por volumen (carrito) ----------
     El renderizado real vive en window.mtActualizarProgresoCarrito (más abajo,
     junto al carrito lateral) para que la página /cart y el side cart compartan
     exactamente la misma lógica de niveles. Esta función solo se encarga de
     inicializar TODAS las instancias presentes en la página (puede haber más
     de una: la del carrito lateral, siempre presente, y la de la página /cart). */
  function initCarritoProgreso() {
    var contenedores = document.querySelectorAll('[data-mt-carrito-progreso]');
    if (!contenedores.length) return;

    function actualizarTodos(cantidad) {
      contenedores.forEach(function (contenedor) {
        window.mtActualizarProgresoCarrito(contenedor, cantidad);
      });
    }

    function actualizarDesdeServidor() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { actualizarTodos(cart.item_count); })
        .catch(function () {});
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count === 'number') {
          actualizarTodos(event.cartData.item_count);
        } else {
          actualizarDesdeServidor();
        }
      });
    }

    actualizarDesdeServidor();
  }

  /* Ejecuta fn en el próximo frame; si requestAnimationFrame no llega a disparar
     (pestaña en segundo plano, etc.) hay una red de seguridad por timeout. */
  function mtSiguienteFrame(fn) {
    var hecho = false;
    function ejecutar() { if (hecho) return; hecho = true; fn(); }
    requestAnimationFrame(ejecutar);
    window.setTimeout(ejecutar, 60);
  }

  /* ---------- Carrito lateral (side cart) ---------- */
  function formatoDineroGlobal(centavos) {
    var numero = ((centavos || 0) / 100).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return numero + ' €';
  }

  function initCarritoLateral() {
    var raiz = document.querySelector('[data-mt-carrito-lateral]');
    if (!raiz) return null;

    var panel = raiz.querySelector('.mt-carrito-lateral__panel');
    var lineasEl = raiz.querySelector('[data-mt-carrito-lineas]');
    var vacioEl = raiz.querySelector('[data-mt-carrito-vacio]');
    var pieEl = raiz.querySelector('[data-mt-carrito-pie]');
    var subtotalEl = raiz.querySelector('[data-mt-carrito-subtotal]');
    var crossSellEl = raiz.querySelector('[data-mt-carrito-cross-sell]');
    var crossSellGrid = raiz.querySelector('[data-mt-carrito-cross-sell-grid]');
    var lineaPlantilla = document.querySelector('[data-mt-carrito-linea-plantilla]');
    var crossPlantilla = document.querySelector('[data-mt-carrito-cross-sell-plantilla]');
    var cartIcon = document.getElementById('cart-icon-bubble');
    var ultimoProductoAgregado = null;
    var crossSellCargadoPara = null;

    function abrir() {
      raiz.hidden = false;
      mtSiguienteFrame(function () {
        raiz.classList.add('mt-abierto');
        document.body.classList.add('mt-carrito-abierto');
      });
    }

    function cerrar() {
      raiz.classList.remove('mt-abierto');
      document.body.classList.remove('mt-carrito-abierto');
      window.setTimeout(function () { raiz.hidden = true; }, 400);
    }

    raiz.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-mt-carrito-cerrar]')) cerrar();
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && raiz.classList.contains('mt-abierto')) cerrar();
    });

    function actualizarIconoCabecera(cart) {
      if (!cartIcon) return;
      var burbuja = cartIcon.querySelector('.cart-count-bubble');
      if (cart.item_count > 0) {
        if (!burbuja) {
          burbuja = document.createElement('div');
          burbuja.className = 'cart-count-bubble';
          cartIcon.appendChild(burbuja);
        }
        burbuja.innerHTML = (cart.item_count < 100 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '') +
          '<span class="visually-hidden">' + cart.item_count + ' artículos</span>';
      } else if (burbuja) {
        burbuja.remove();
      }
    }

    function crearLinea(item) {
      var nodo = lineaPlantilla.content.firstElementChild.cloneNode(true);
      nodo.setAttribute('data-linea-key', item.key);
      var enlaces = nodo.querySelectorAll('[data-linea-enlace]');
      enlaces.forEach(function (a) { a.setAttribute('href', item.url); });
      var img = nodo.querySelector('[data-linea-img]');
      if (img) {
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        img.alt = item.title || '';
      }
      var titulo = nodo.querySelector('[data-linea-titulo]');
      if (titulo) titulo.textContent = item.product_title || item.title;
      var variante = nodo.querySelector('[data-linea-variante]');
      if (variante) variante.textContent = item.variant_title || '';
      var cantidadEl = nodo.querySelector('[data-linea-cantidad]');
      if (cantidadEl) cantidadEl.textContent = item.quantity;
      var precioEl = nodo.querySelector('[data-linea-precio]');
      if (precioEl) precioEl.textContent = formatoDineroGlobal(item.final_line_price);

      var menos = nodo.querySelector('[data-linea-menos]');
      var mas = nodo.querySelector('[data-linea-mas]');
      var eliminar = nodo.querySelector('[data-linea-eliminar]');
      if (menos) menos.addEventListener('click', function () { cambiarCantidad(item.key, item.quantity - 1, nodo); });
      if (mas) mas.addEventListener('click', function () { cambiarCantidad(item.key, item.quantity + 1, nodo); });
      if (eliminar) eliminar.addEventListener('click', function () { cambiarCantidad(item.key, 0, nodo); });

      return nodo;
    }

    function renderCarrito(cart) {
      lineasEl.innerHTML = '';
      if (!cart.items.length) {
        vacioEl.hidden = false;
        pieEl.hidden = true;
        crossSellEl.hidden = true;
      } else {
        vacioEl.hidden = true;
        pieEl.hidden = false;
        cart.items.forEach(function (item) {
          lineasEl.appendChild(crearLinea(item));
        });
        if (subtotalEl) subtotalEl.textContent = formatoDineroGlobal(cart.total_price);
      }
      actualizarIconoCabecera(cart);

      var progresoEl = raiz.querySelector('[data-mt-carrito-progreso]');
      if (progresoEl && typeof window.mtActualizarProgresoCarrito === 'function') {
        window.mtActualizarProgresoCarrito(progresoEl, cart.item_count);
      }
    }

    function actualizarDesdeServidor(callback) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCarrito(cart);
          if (typeof callback === 'function') callback(cart);
        })
        .catch(function () {});
    }

    function cambiarCantidad(key, cantidad, nodoLinea) {
      if (nodoLinea) nodoLinea.classList.add('mt-actualizando');
      fetch(window.routes.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: cantidad })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCarrito(cart);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-carrito-lateral', cartData: cart });
          }
        })
        .catch(function () {
          if (nodoLinea) nodoLinea.classList.remove('mt-actualizando');
        });
    }

    function cargarCrossSell(productId) {
      if (!productId || crossSellCargadoPara === productId) return;
      crossSellCargadoPara = productId;
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=4&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var productos = (data && data.products) || [];
          if (!productos.length || !crossPlantilla) { crossSellEl.hidden = true; return; }
          crossSellGrid.innerHTML = '';
          productos.slice(0, 4).forEach(function (p) {
            var nodo = crossPlantilla.content.firstElementChild.cloneNode(true);
            nodo.setAttribute('href', p.url);
            var img = nodo.querySelector('[data-cross-img]');
            if (img && p.featured_image) { img.src = p.featured_image; img.alt = p.title; }
            nodo.querySelector('[data-cross-titulo]').textContent = p.title;
            nodo.querySelector('[data-cross-precio]').textContent = formatoDineroGlobal(p.price);
            crossSellGrid.appendChild(nodo);
          });
          crossSellEl.hidden = false;
        })
        .catch(function () { crossSellEl.hidden = true; });
    }

    function agregarProducto(formData) {
      return fetch(window.routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (resultado) {
          if (!resultado.ok) {
            var err = new Error(resultado.data.description || resultado.data.message || 'No se pudo añadir el producto.');
            err.payload = resultado.data;
            throw err;
          }
          ultimoProductoAgregado = resultado.data.product_id;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: resultado.data.variant_id, cartData: resultado.data });
          } else {
            // Sin sistema de pub-sub disponible: refrescamos y abrimos directamente.
            actualizarDesdeServidor(function () { abrir(); cargarCrossSell(ultimoProductoAgregado); });
          }
          return resultado.data;
        });
    }

    if (cartIcon) {
      cartIcon.addEventListener('click', function (evt) {
        evt.preventDefault();
        actualizarDesdeServidor(abrir);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var fuente = event && event.source;
        actualizarDesdeServidor(function () {
          if (fuente !== 'cart-items' && fuente !== 'mt-carrito-lateral') {
            abrir();
            cargarCrossSell(ultimoProductoAgregado);
          }
        });
      });
    }

    return { abrir: abrir, cerrar: cerrar, agregarProducto: agregarProducto, actualizarDesdeServidor: actualizarDesdeServidor };
  }

  /* Barra de progreso: expone una función reutilizable (usada por el carrito lateral y por
     la sección de página completa /cart, que sigue funcionando de forma independiente). */
  window.mtActualizarProgresoCarrito = function (contenedor, cantidad) {
    var mensajeEl = contenedor.querySelector('[data-mt-carrito-progreso-mensaje]');
    var rellenoEl = contenedor.querySelector('[data-mt-carrito-progreso-relleno]');
    var nivelesEl = contenedor.querySelector('[data-mt-carrito-progreso-niveles]');
    var niveles;
    try { niveles = JSON.parse(nivelesEl.textContent); } catch (e) { niveles = []; }
    if (!niveles.length) return;
    niveles.sort(function (a, b) { return a.minimo - b.minimo; });

    var nivelMaximo = Number(contenedor.getAttribute('data-nivel-maximo')) || niveles[niveles.length - 1].minimo;

    contenedor.hidden = false;
    var mensaje = '';
    var siguiente = null;
    for (var j = 0; j < niveles.length; j++) {
      if (niveles[j].minimo > cantidad) { siguiente = niveles[j]; break; }
    }
    if (siguiente) {
      var faltan = siguiente.minimo - cantidad;
      mensaje = '¡Añade ' + faltan + ' artículo' + (faltan === 1 ? '' : 's') + ' para conseguir un ' + siguiente.porcentaje + '% adicional!';
    } else {
      var ultimo = niveles[niveles.length - 1];
      mensaje = '¡Has desbloqueado un ' + ultimo.porcentaje + '% de descuento!';
    }

    if (mensajeEl) mensajeEl.textContent = mensaje;
    if (rellenoEl) {
      var pctBarra = Math.min(100, Math.max(0, (cantidad / nivelMaximo) * 100));
      rellenoEl.style.width = pctBarra + '%';
    }
  };

  /* ---------- Contador de reserva de la cesta (10:00 -> 00:00) ---------- */
  function initCarritoReserva() {
    var el = document.querySelector('[data-mt-carrito-reserva-tiempo]');
    if (!el) return;

    function formatear(segundos) {
      var m = Math.floor(segundos / 60);
      var s = segundos % 60;
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }

    var segundosRestantes = 600;
    el.textContent = formatear(segundosRestantes);
    var intervalo = window.setInterval(function () {
      segundosRestantes -= 1;
      if (segundosRestantes <= 0) {
        segundosRestantes = 0;
        el.textContent = formatear(segundosRestantes);
        window.clearInterval(intervalo);
        return;
      }
      el.textContent = formatear(segundosRestantes);
    }, 1000);
  }

  /* ---------- Página de carrito (rediseño completo, AJAX sin recargar) ---------- */
  function initCarritoPagina() {
    var raiz = document.querySelector('[data-mt-carrito-pagina]');
    if (!raiz) return;

    var cuerpo = raiz.querySelector('[data-mt-carrito-pagina-cuerpo]');
    var vacio = raiz.querySelector('[data-mt-carrito-pagina-vacio]');
    var reservaEl = raiz.querySelector('[data-mt-carrito-reserva]');
    var lineasEl = raiz.querySelector('[data-mt-carrito-pagina-lineas]');
    var subtotalEl = raiz.querySelector('[data-mt-carrito-pagina-subtotal]');
    var descuentoFila = raiz.querySelector('[data-mt-carrito-pagina-descuento-fila]');
    var descuentoEl = raiz.querySelector('[data-mt-carrito-pagina-descuento]');
    var plantilla = document.querySelector('[data-mt-carrito-pagina-linea-plantilla]');
    var cartIcon = document.getElementById('cart-icon-bubble');

    function actualizarIconoCabecera(cart) {
      if (!cartIcon) return;
      var burbuja = cartIcon.querySelector('.cart-count-bubble');
      if (cart.item_count > 0) {
        if (!burbuja) {
          burbuja = document.createElement('div');
          burbuja.className = 'cart-count-bubble';
          cartIcon.appendChild(burbuja);
        }
        burbuja.innerHTML = (cart.item_count < 100 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '') +
          '<span class="visually-hidden">' + cart.item_count + ' artículos</span>';
      } else if (burbuja) {
        burbuja.remove();
      }
    }

    function cambiarCantidad(key, cantidad) {
      fetch(window.routes.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: cantidad })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCarrito(cart);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
          }
        });
    }

    function wireLinea(nodo, key) {
      var cantidadEl = nodo.querySelector('[data-linea-cantidad]');
      var menos = nodo.querySelector('[data-linea-menos]');
      var mas = nodo.querySelector('[data-linea-mas]');
      var eliminar = nodo.querySelector('[data-linea-eliminar]');
      function cantidadActual() { return Number(cantidadEl.textContent) || 1; }
      if (menos) menos.addEventListener('click', function () { cambiarCantidad(key, cantidadActual() - 1); });
      if (mas) mas.addEventListener('click', function () { cambiarCantidad(key, cantidadActual() + 1); });
      if (eliminar) eliminar.addEventListener('click', function () { cambiarCantidad(key, 0); });
    }

    function crearLinea(item) {
      var nodo = plantilla.content.firstElementChild.cloneNode(true);
      nodo.setAttribute('data-linea-key', item.key);
      nodo.querySelectorAll('[data-linea-enlace]').forEach(function (a) { a.setAttribute('href', item.url); });
      var img = nodo.querySelector('[data-linea-img]');
      if (img) { img.src = item.image || ''; img.alt = item.title || ''; }
      var titulo = nodo.querySelector('[data-linea-titulo]');
      if (titulo) titulo.textContent = item.product_title || item.title;
      var variante = nodo.querySelector('[data-linea-variante]');
      if (variante) variante.textContent = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var cantidadEl = nodo.querySelector('[data-linea-cantidad]');
      if (cantidadEl) cantidadEl.textContent = item.quantity;
      var precioEl = nodo.querySelector('[data-linea-precio]');
      if (precioEl) precioEl.textContent = formatoDineroGlobal(item.final_line_price);
      var precioAnteriorEl = nodo.querySelector('[data-linea-precio-anterior]');
      if (precioAnteriorEl) {
        if (item.original_line_price !== item.final_line_price) {
          precioAnteriorEl.textContent = formatoDineroGlobal(item.original_line_price);
          precioAnteriorEl.hidden = false;
        } else {
          precioAnteriorEl.hidden = true;
        }
      }
      wireLinea(nodo, item.key);
      return nodo;
    }

    function renderCarrito(cart) {
      lineasEl.innerHTML = '';
      if (!cart.items.length) {
        if (vacio) vacio.hidden = false;
        if (cuerpo) cuerpo.hidden = true;
        if (reservaEl) reservaEl.hidden = true;
      } else {
        if (vacio) vacio.hidden = true;
        if (cuerpo) cuerpo.hidden = false;
        if (reservaEl) reservaEl.hidden = false;
        cart.items.forEach(function (item) { lineasEl.appendChild(crearLinea(item)); });
        if (subtotalEl) subtotalEl.textContent = formatoDineroGlobal(cart.total_price);
        if (descuentoFila) {
          if (cart.total_discount > 0) {
            descuentoFila.hidden = false;
            if (descuentoEl) descuentoEl.textContent = '−' + formatoDineroGlobal(cart.total_discount);
          } else {
            descuentoFila.hidden = true;
          }
        }
      }
      actualizarIconoCabecera(cart);
      document.querySelectorAll('[data-mt-carrito-progreso]').forEach(function (el) {
        window.mtActualizarProgresoCarrito(el, cart.item_count);
      });
    }

    // Las líneas ya renderizadas por Liquid en la carga inicial solo necesitan sus listeners.
    lineasEl.querySelectorAll('.mt-carrito-pagina__linea').forEach(function (nodo) {
      wireLinea(nodo, nodo.getAttribute('data-linea-key'));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'cart-items') return; // ya gestionado por cambiarCantidad()
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(renderCarrito);
      });
    }
  }

  /* ---------- Formulario de producto -> carrito lateral (AJAX, sin recargar página) ---------- */
  function initFormularioCarrito(carrito) {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var boton = form.querySelector('[data-mt-boton-add]');
        var errorEl = form.querySelector('[data-mt-producto-error]');
        if (boton && boton.disabled) return;
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        if (boton) { boton.disabled = true; boton.classList.add('mt-cargando'); }

        var formData = new FormData(form);

        function restaurarBoton() {
          if (!boton) return;
          boton.disabled = false;
          boton.classList.remove('mt-cargando');
        }

        if (carrito) {
          carrito.agregarProducto(formData)
            .then(function () { restaurarBoton(); })
            .catch(function (err) {
              restaurarBoton();
              if (errorEl) {
                errorEl.hidden = false;
                errorEl.textContent = err.message;
              }
            });
        } else {
          // Sin carrito lateral disponible: comportamiento nativo (envío normal del formulario).
          form.submit();
        }
      });
    });
  }

  /* ---------- Popup de conversión ---------- */
  function initPopupConversion() {
    var raiz = document.querySelector('[data-mt-popup]');
    if (!raiz) return;

    var LS_KEY = 'mt_popup_estado';
    var LS_TS = 'mt_popup_fecha';
    var DIAS_ENFRIAMIENTO = 7;

    function estadoGuardado() {
      try { return window.localStorage.getItem(LS_KEY); } catch (e) { return null; }
    }
    function guardarEstado(valor) {
      try {
        window.localStorage.setItem(LS_KEY, valor);
        window.localStorage.setItem(LS_TS, String(Date.now()));
      } catch (e) { /* localStorage no disponible: el popup simplemente podrá volver a mostrarse */ }
    }
    function dentroDeEnfriamiento() {
      try {
        var ts = Number(window.localStorage.getItem(LS_TS));
        if (!ts) return false;
        return (Date.now() - ts) < DIAS_ENFRIAMIENTO * 24 * 60 * 60 * 1000;
      } catch (e) { return false; }
    }

    var recienEnviado = raiz.hasAttribute('data-mt-popup-recien-enviado');
    var yaMostrado = false;

    function abrir() {
      if (yaMostrado) return;
      yaMostrado = true;
      raiz.hidden = false;
      mtSiguienteFrame(function () { raiz.classList.add('mt-abierto'); });
    }

    function cerrar(comoSuscrito) {
      raiz.classList.remove('mt-abierto');
      window.setTimeout(function () { raiz.hidden = true; }, 400);
      guardarEstado(comoSuscrito ? 'suscrito' : 'cerrado');
    }

    raiz.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-mt-popup-cerrar]')) cerrar(false);
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && raiz.classList.contains('mt-abierto')) cerrar(false);
    });

    /* El formulario se envía de forma NATIVA (recarga de página), sin
       preventDefault: los formularios de cliente de Shopify pasan por su
       propia validación anti-spam (captcha), que solo se resuelve con un
       envío real del navegador — un fetch/AJAX directo lo rechaza siempre.
       Por eso, tras el envío, Shopify recarga la página y Liquid nos dice
       si se guardó bien (form.posted_successfully?) mediante el atributo
       data-mt-popup-recien-enviado; en ese caso mostramos el popup ya
       abierto con el código de bienvenida. */
    if (recienEnviado) {
      guardarEstado('suscrito');
      abrir();
      return;
    }

    var estado = estadoGuardado();
    if (estado === 'suscrito') return;
    if (estado === 'cerrado' && dentroDeEnfriamiento()) return;

    /* Triggers: el primero que se cumpla abre el popup. Se arman tras un
       pequeño margen para que nunca aparezca de forma instantánea/agresiva. */
    var MARGEN_INICIAL_MS = 4000;
    var TIEMPO_EN_PAGINA_MS = 20000;
    var UMBRAL_SCROLL = 0.5;

    window.setTimeout(function () {
      var temporizador = window.setTimeout(abrir, TIEMPO_EN_PAGINA_MS);

      function alScroll() {
        var progreso = window.scrollY / Math.max(1, (document.documentElement.scrollHeight - window.innerHeight));
        if (progreso >= UMBRAL_SCROLL) {
          abrir();
          window.removeEventListener('scroll', alScroll);
        }
      }
      window.addEventListener('scroll', alScroll, { passive: true });

      function alSalir(evt) {
        if (evt.clientY <= 0) {
          abrir();
          document.removeEventListener('mouseleave', alSalir);
        }
      }
      document.addEventListener('mouseleave', alSalir);

      // Una vez se abre por cualquier vía, ya no hace falta seguir escuchando.
      var pararTodo = function () {
        window.clearTimeout(temporizador);
        window.removeEventListener('scroll', alScroll);
        document.removeEventListener('mouseleave', alSalir);
      };
      raiz.addEventListener('transitionend', function comprobar() {
        if (raiz.classList.contains('mt-abierto')) { pararTodo(); raiz.removeEventListener('transitionend', comprobar); }
      });
    }, MARGEN_INICIAL_MS);
  }

  /* ---------- Pop-up de la Campaña de Otoño (suscripción + contador 20:00) ---------- */
  function initPopupOtono() {
    var raiz = document.querySelector('[data-mt-popup-otono]');
    if (!raiz) return;

    var LS_KEY = 'mt_popup_otono_estado';
    var LS_TS = 'mt_popup_otono_fecha';
    var SS_EXPIRA = 'mt_popup_otono_expira';
    var DIAS_ENFRIAMIENTO = 7;
    var DURACION_MS = 20 * 60 * 1000;

    function estadoGuardado() {
      try { return window.localStorage.getItem(LS_KEY); } catch (e) { return null; }
    }
    function guardarEstado(valor) {
      try {
        window.localStorage.setItem(LS_KEY, valor);
        window.localStorage.setItem(LS_TS, String(Date.now()));
      } catch (e) { /* localStorage no disponible: el popup simplemente podrá volver a mostrarse */ }
    }
    function dentroDeEnfriamiento() {
      try {
        var ts = Number(window.localStorage.getItem(LS_TS));
        if (!ts) return false;
        return (Date.now() - ts) < DIAS_ENFRIAMIENTO * 24 * 60 * 60 * 1000;
      } catch (e) { return false; }
    }

    var recienEnviado = raiz.hasAttribute('data-mt-popup-otono-recien-enviado');
    var yaMostrado = false;

    function abrir() {
      if (yaMostrado) return;
      yaMostrado = true;
      raiz.hidden = false;
      mtSiguienteFrame(function () { raiz.classList.add('mt-abierto'); });
    }

    function cerrar(comoSuscrito) {
      raiz.classList.remove('mt-abierto');
      window.setTimeout(function () { raiz.hidden = true; }, 400);
      guardarEstado(comoSuscrito ? 'suscrito' : 'cerrado');
    }

    raiz.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-mt-popup-otono-cerrar]')) cerrar(false);
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && raiz.classList.contains('mt-abierto')) cerrar(false);
    });

    /* Contador real de 20:00 -> 00:00. La hora de expiración (no un simple
       contador en memoria) se guarda en sessionStorage la primera vez que se
       muestra el código, para que el tiempo restante sea siempre correcto
       aunque la pestaña se recargue durante la ventana de la oferta. */
    function formatear(segundos) {
      var m = Math.floor(segundos / 60);
      var s = segundos % 60;
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }

    function iniciarContador() {
      var contadorEl = raiz.querySelector('[data-mt-popup-otono-contador-tiempo]');
      var contadorWrap = raiz.querySelector('[data-mt-popup-otono-contador-wrap]');
      var expiradoEl = raiz.querySelector('[data-mt-popup-otono-expirado]');

      var expira;
      try {
        var guardado = Number(window.sessionStorage.getItem(SS_EXPIRA));
        if (guardado) {
          expira = guardado;
        } else {
          expira = Date.now() + DURACION_MS;
          window.sessionStorage.setItem(SS_EXPIRA, String(expira));
        }
      } catch (e) {
        expira = Date.now() + DURACION_MS;
      }

      var intervalo;
      function tick() {
        var restanteMs = expira - Date.now();
        if (restanteMs <= 0) {
          if (contadorWrap) contadorWrap.hidden = true;
          if (expiradoEl) expiradoEl.hidden = false;
          if (intervalo) window.clearInterval(intervalo);
          return;
        }
        if (contadorEl) contadorEl.textContent = formatear(Math.ceil(restanteMs / 1000));
      }
      tick();
      intervalo = window.setInterval(tick, 1000);
    }

    if (recienEnviado) {
      guardarEstado('suscrito');
      abrir();
      iniciarContador();
      return;
    }

    var estado = estadoGuardado();
    if (estado === 'suscrito') return;
    if (estado === 'cerrado' && dentroDeEnfriamiento()) return;

    var MARGEN_INICIAL_MS = 4000;
    var TIEMPO_EN_PAGINA_MS = 20000;
    var UMBRAL_SCROLL = 0.5;

    window.setTimeout(function () {
      var temporizador = window.setTimeout(abrir, TIEMPO_EN_PAGINA_MS);

      function alScroll() {
        var progreso = window.scrollY / Math.max(1, (document.documentElement.scrollHeight - window.innerHeight));
        if (progreso >= UMBRAL_SCROLL) {
          abrir();
          window.removeEventListener('scroll', alScroll);
        }
      }
      window.addEventListener('scroll', alScroll, { passive: true });

      function alSalir(evt) {
        if (evt.clientY <= 0) {
          abrir();
          document.removeEventListener('mouseleave', alSalir);
        }
      }
      document.addEventListener('mouseleave', alSalir);

      var pararTodo = function () {
        window.clearTimeout(temporizador);
        window.removeEventListener('scroll', alScroll);
        document.removeEventListener('mouseleave', alSalir);
      };
      raiz.addEventListener('transitionend', function comprobar() {
        if (raiz.classList.contains('mt-abierto')) { pararTodo(); raiz.removeEventListener('transitionend', comprobar); }
      });
    }, MARGEN_INICIAL_MS);
  }

  function initVideoHero() {
    if (!reducedMotion()) return;
    document.querySelectorAll('.mt-hero-video__video').forEach(function (v) {
      v.pause();
      v.removeAttribute('autoplay');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initParallax();
    initCarrusel();
    initVariantes();
    initSwatches();
    initCantidad();
    initGaleria();
    initMenu();
    initContadores();
    initVideoHero();
    initCarritoProgreso();
    var carritoLateral = initCarritoLateral();
    initFormularioCarrito(carritoLateral);
    initPopupConversion();
    initPopupOtono();
    initCarritoPagina();
    initCarritoReserva();
  });
})();
